import * as React from "react";
import { Check, X, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const comparisonData = [{
  trait: "After-Hours Strategy",
  callTaker: "Generic Answering Services",
  systemOwner: "Zero-Latency Triage & Booking"
}, {
  trait: "Lead Capture",
  callTaker: "Lead Leakage",
  systemOwner: "ServiceTitan & Housecall Pro Sync"
}, {
  trait: "Operational Focus",
  callTaker: "Spectator Mentality",
  systemOwner: "The Visionary $50k+ Standard"
}, {
  trait: "Revenue Mindset",
  callTaker: "Hobbyist Hustle",
  systemOwner: "The Mother's House Commitment"
}];
export default function AreYouABestFit() {
  return <section id="are-you-a-best-fit" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden border-t border-border">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none"></div>

      <div className="container mx-auto px-4 md:px-8 max-w-6xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          
          <div className="lg:col-span-5 flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 border border-primary/30 bg-primary/10 w-fit">
              <ShieldAlert className="size-4 text-primary" />
              <span className="text-xs font-mono uppercase tracking-widest text-primary font-semibold">
                SYSTEM ELIGIBILITY PROTOCOL
              </span>
            </div>
            
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-foreground mb-6 leading-[1.1]">
              <span>THE LINE IN THE</span>{" "}
              <span className="text-primary">SAND</span>
            </h2>
            
            <p className="font-sans text-lg text-muted-foreground mb-8 leading-relaxed max-w-xl">
              We don't hire out services; we install permanent infrastructure. Do you qualify?
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4 mt-auto">
              <Link to="/OperationalAuditPage">
                <Button size="lg" className="font-serif uppercase tracking-wider rounded-none border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-base w-full sm:w-auto shadow-2xl shadow-primary/40 ring-1 ring-primary border-primary/50 bg-primary/95 backdrop-blur-sm hover:scale-105 transition-all">
                  Begin Operational Audit
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="border-2 border-border bg-card/40 backdrop-blur-sm p-1 shadow-2xl">
              <Table>
                <TableHeader>
                  <TableRow className="border-border hover:bg-transparent">
                    <TableHead className="font-serif text-sm md:text-base text-foreground w-[30%] uppercase tracking-wider">
                      Operational Trait
                    </TableHead>
                    <TableHead className="font-serif text-sm md:text-base text-muted-foreground w-[35%] uppercase tracking-wider">
                      The "Call Taker"
                    </TableHead>
                    <TableHead className="font-serif text-sm md:text-base text-primary w-[35%] uppercase tracking-wider">
                      The "System Owner"
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="border-border/50 hover:bg-muted/30 transition-colors group">
                      <TableCell className="font-sans font-medium text-foreground py-5 align-top md:align-middle">
                        {row.trait}
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground py-5 align-top md:align-middle">
                        <div className="flex items-start md:items-center gap-2">
                          <X className="size-4 text-destructive shrink-0 mt-1 md:mt-0 opacity-70 group-hover:opacity-100 transition-opacity" />
                          <span className="leading-tight">{row.callTaker}</span>
                        </div>
                      </TableCell>
                      <TableCell className="font-sans text-foreground font-semibold py-5 align-top md:align-middle bg-primary/5">
                        <div className="flex items-start md:items-center gap-2">
                          <Check className="size-4 text-primary shrink-0 mt-1 md:mt-0" />
                          <span className="leading-tight">{row.systemOwner}</span>
                        </div>
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>
            
            <div className="mt-4 flex justify-end">
               <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest flex items-center gap-2">
                  <span className="inline-block w-2 h-2 bg-primary rounded-none animate-pulse"></span>
                  System Status: Evaluating
               </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}